import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = authed
  const [exec, setExec] = useState(null); // group executive context (or {has_group_access:false})
  const [loading, setLoading] = useState(true);

  const loadExec = useCallback(async () => {
    try {
      const { data } = await api.get("/executive/context");
      setExec(data);
      return data;
    } catch {
      setExec({ has_group_access: false });
      return { has_group_access: false };
    }
  }, []);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      const ex = await loadExec();
      return { user: data, exec: ex };
    } catch {
      setUser(false);
      setExec({ has_group_access: false });
      return { user: false, exec: { has_group_access: false } };
    } finally {
      setLoading(false);
    }
  }, [loadExec]);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    setUser(false);
    setExec(null);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, setUser, exec, setExec, loadExec, loading, checkAuth, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);

// Where a freshly authenticated user should land.
export function landingPath(exec, user) {
  // Owner/admin always keep their normal flow and reach the admin console from the menu.
  if (user && ["owner", "admin"].includes(user.role)) return "/dashboard";
  if (exec && exec.has_group_access && !exec.active_location) return "/executive";
  return "/dashboard";
}
